"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormComboBox", {
    enumerable: true,
    get: function() {
        return FormComboBox;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _reactdom = require("@floating-ui/react-dom");
const _FormComboBoxContext = require("./FormComboBoxContext");
const _scrollIntoViewIfNeeded = require("../../../util/scrollIntoViewIfNeeded");
const _useFloatingHideListeners = require("../../../hooks/useFloatingHideListeners");
const _Theme = require("../../../contexts/Theme");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormComboBox = (param)=>{
    let { children, onSelect, items, onChange: onChangeInput, defaultValue, menuWidth = "available" } = param;
    const [highlighted, setHighlighted] = (0, _react.useState)(0);
    const [focused, setFocused] = (0, _react.useState)(false);
    var _defaultValue_value;
    const [value, setValue] = (0, _react.useState)((_defaultValue_value = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) !== null && _defaultValue_value !== void 0 ? _defaultValue_value : "");
    const { focusOutline } = (0, _Theme.useTheme)();
    const floating = (0, _reactdom.useFloating)({
        placement: "bottom-start",
        middleware: [
            (0, _reactdom.shift)(),
            (0, _reactdom.flip)(),
            (0, _reactdom.offset)(parseInt(focusOutline.size, 10)),
            (0, _reactdom.size)({
                apply (param) {
                    let { availableWidth, rects } = param;
                    if (floating.refs.floating.current != null) {
                        const width = menuWidth === "available" ? availableWidth : rects.reference.width;
                        floating.refs.floating.current.style.width = "".concat(width, "px");
                    }
                }
            })
        ]
    });
    const internalRefs = (0, _react.useRef)([]);
    (0, _react.useEffect)(()=>{
        internalRefs.current = internalRefs.current.slice(0, items.length);
        if (items.length > 0) {
            setHighlighted(0);
        }
    }, [
        items
    ]);
    (0, _useFloatingHideListeners.useFloatingHideListeners)({
        onHide: setFocused.bind(null, false),
        floating
    });
    const itemRefs = (0, _react.useMemo)(()=>{
        const refList = [];
        for(let i = 0; i < items.length; i++){
            refList.push((el)=>{
                internalRefs.current[i] = el;
            });
        }
        return refList;
    }, [
        items
    ]);
    const setSelected = (0, _react.useCallback)((selected)=>{
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(items[selected]);
        setFocused(false);
        setValue(items[selected].value);
    }, [
        onSelect,
        items,
        setValue,
        setFocused
    ]);
    const clearValue = (0, _react.useCallback)(()=>{
        setValue("");
    }, [
        setValue
    ]);
    const onKeyDown = (0, _react.useMemo)(()=>(e)=>{
            switch(e.key){
                default:
                    setFocused(true);
                    return;
                case "Down":
                case "ArrowDown":
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!focused) {
                            setHighlighted(0);
                            setFocused(true);
                            return;
                        }
                        const next = Math.min(items.length - 1, highlighted + 1);
                        setHighlighted(next);
                        (0, _scrollIntoViewIfNeeded.scrollIntoViewIfNeeded)(internalRefs.current[next]);
                        break;
                    }
                case "Up":
                case "ArrowUp":
                    {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!focused) {
                            return;
                        }
                        const prev = Math.max(0, highlighted - 1);
                        setHighlighted(prev);
                        (0, _scrollIntoViewIfNeeded.scrollIntoViewIfNeeded)(internalRefs.current[prev]);
                        break;
                    }
                case "Enter":
                    e.preventDefault();
                    e.stopPropagation();
                    setSelected(highlighted);
                    break;
                case "Tab":
                    break;
            }
        }, [
        items,
        highlighted,
        setHighlighted,
        setSelected,
        internalRefs,
        focused
    ]);
    const onFocus = ()=>{
        setFocused(true);
    };
    const onChange = (0, _react.useCallback)((e)=>{
        setValue(e.target.value);
        onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(e);
    }, [
        setValue,
        onChangeInput
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_FormComboBoxContext.FormComboBoxContext.Provider, {
        value: {
            highlighted,
            setHighlighted,
            setSelected,
            items,
            inputProps: {
                onKeyDown,
                onFocus,
                onChange,
                value,
                role: "combobox"
            },
            itemRefs,
            focused,
            setFocused,
            floating,
            clearValue
        }
    }, /*#__PURE__*/ _react.default.createElement(_FormComboBoxContext.FormComboBoxContext.Consumer, null, children)));
};

//# sourceMappingURL=FormComboBox.js.map